var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as API from './api';
let Ingress = class Ingress extends Vue {
    constructor() {
        super(...arguments);
        this.mode = 'login';
        this.message = '';
        this.mail = '';
        this.password = '';
        this.confirm = '';
        this.name = '';
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.mode == 'login') {
                let result = yield API.emit('/user/login', {
                    mail: this.mail,
                    password: this.password,
                });
                switch (result) {
                    case 'Success':
                        location.href = '/';
                        break;
                    default:
                        this.message = 'Incorrect mail or password';
                        break;
                }
            }
            else if (this.mode == 'register') {
                if (this.password != this.confirm) {
                    this.message = '兩次密碼不相同';
                    return;
                }
                let result = yield API.emit('/user/register', {
                    mail: this.mail,
                    password: this.password,
                    name: this.name,
                });
                switch (result) {
                    case 'Success':
                        yield API.emit('/user/login', {
                            mail: this.mail,
                            password: this.password,
                        });
                        location.href = '/';
                        break;
                    case 'Eexist':
                        this.message = '信箱已被註冊';
                        break;
                }
            }
            else if (this.mode == 'forget') {
                let result = yield API.emit('/user/get_reset', {
                    mail: this.mail,
                });
                console.log(result);
                switch (result) {
                    case 'Success':
                        this.message = '請至email連結重設密碼';
                        break;
                    default:
                        this.message = '此信箱尚未註冊';
                        break;
                }
            }
        });
    }
    onRegister() {
        if (this.mode == 'login') {
            this.mode = 'register';
        }
        else if (this.mode == 'register') {
            this.onSubmit();
        }
    }
    onCancel() {
        this.mode = 'login';
    }
    onForget() {
        this.mode = 'forget';
    }
};
Ingress = __decorate([
    Component
], Ingress);
export default Ingress;



// WEBPACK FOOTER //
// ./src/Ingress.vue